import React from 'react'
import { Input } from '../../../components/ui/Input'
import { Button } from '../../../components/ui/Button'
import { apiFetch } from '../../../lib/api-client'

interface BogforingTabProps {
  companyId: string
  initial: Record<string, string> | null
  onSaved: (updated: Record<string, string>) => void
}

const GL_FIELDS: { key: string; label: string; placeholder: string }[] = [
  { key: 'leje',     label: 'Husleje',          placeholder: '1010' },
  { key: 'varme',    label: 'A conto varme',     placeholder: '1020' },
  { key: 'vand',     label: 'A conto vand',      placeholder: '1021' },
  { key: 'el',       label: 'A conto el',        placeholder: '1022' },
  { key: 'koling',   label: 'A conto køling',    placeholder: '1023' },
  { key: 'antenne',  label: 'Antennebidrag',     placeholder: '1030' },
  { key: 'internet', label: 'Internetbidrag',    placeholder: '1031' },
  { key: 'ovrige',   label: 'Øvrige',            placeholder: '1040' },
]

const wrap: React.CSSProperties = { marginBottom: 14 }

export function BogforingTab({ companyId, initial, onSaved }: BogforingTabProps) {
  const [form, setForm] = React.useState<Record<string, string>>(() => {
    const base: Record<string, string> = {}
    for (const f of GL_FIELDS) {
      base[f.key] = initial?.[f.key] ?? ''
    }
    return base
  })
  const [saving, setSaving] = React.useState(false)
  const [saved, setSaved] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    setSaving(true)
    setError(null)
    setSaved(false)

    // Omit empty strings so cleared fields fall back to server defaults
    const payload: Record<string, string> = {}
    for (const f of GL_FIELDS) {
      const v = form[f.key].trim()
      if (v) payload[f.key] = v
    }

    try {
      const updated = await apiFetch<{ gl_accounts: Record<string, string> | null }>(
        `/api/v1/companies/${companyId}`,
        {
          method: 'PATCH',
          body: JSON.stringify({ gl_accounts: payload }),
        },
      )
      onSaved(updated.gl_accounts ?? payload)
      setSaved(true)
    } catch {
      setError('Kunne ikke gemme. Prøv igen.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div style={{ maxWidth: 520, padding: '24px 28px' }}>
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a', marginBottom: 4 }}>
          Bogføringskonti
        </div>
        <div style={{ fontSize: 12, color: '#64748b' }}>
          Kontonumre til automatisk bogføring af lejeydelser. Et tomt felt bruger systemets standardkonto (vist som placeholder).
        </div>
      </div>

      <form onSubmit={handleSave}>
        {GL_FIELDS.map((f) => (
          <div key={f.key} style={wrap}>
            <Input
              label={f.label}
              value={form[f.key]}
              onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
              placeholder={f.placeholder}
            />
          </div>
        ))}

        {error && <p style={{ fontSize: 12, color: '#dc2626', marginBottom: 12 }}>{error}</p>}
        {saved && <p style={{ fontSize: 12, color: '#16a34a', marginBottom: 12 }}>Gemt.</p>}

        <Button type="submit" isLoading={saving}>Gem</Button>
      </form>
    </div>
  )
}
